// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__Nagjt","footer":"ChangeClinic_footer__1v85D"};